import HandlerInstance from "../models/handler.instance.js";
/**
 * The internal resolver
 * Here handler functions and relative keys are stored and retrieved.
 *
 * @export
 * @class Resolver
 * @implements {IResolver}
 */
var Resolver = /** @class */ (function () {
    function Resolver() {
        // Contains the mapping of the functions
        this._instances = [];
    }
    /**
     * Retrieve a func from the container
     *
     * @template T
     * @param {string} name The instance name to retrieve
     * @returns {T}
     * @memberof Resolver
     */
    Resolver.prototype.resolve = function (name) {
        var e = this._instances.find(function (p) { return p.name === name; });
        if (!e)
            throw new Error("Cannot find element with key: ".concat(name));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var handlerFx = e.value;
        return new handlerFx();
    };
    /**
     * Add a func and name to the container
     *
     * @param {string} name The instance name to add to the container
     * @param {Function} fx The function to store with the instance name
     * @memberof Resolver
     */
    Resolver.prototype.add = function (name, fx) {
        var k = this._instances.find(function (p) { return p.name === name; });
        if (k === undefined)
            this._instances.push(new HandlerInstance(name, fx));
        else
            throw new Error("The key ".concat(name, " is already been added"));
    };
    /**
     * Remove an isntance from the container
     *
     * @param {string} name The instance name to remove from the container
     * @memberof Resolver
     */
    Resolver.prototype.remove = function (name) {
        var i = this._instances.findIndex(function (p) { return p.name === name; });
        if (i >= 0) {
            this._instances.splice(i, 1);
        }
    };
    /**
     * Clear the container
     *
     * @memberof Resolver
     */
    Resolver.prototype.clear = function () {
        this._instances = [];
    };
    return Resolver;
}());
export default Resolver;
//# sourceMappingURL=resolver.js.map